import RuleActionJumpTo from '../RuleActionJumpTo';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import { removeActionAt } from 'components/Rules/helpers/ruleUpdates';
import RuleActionFields from 'components/Rules/RuleAction';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import type { TQuestionRule, TQuestionRuleAction } from 'types/rules.types';

interface Props {
  rule: TQuestionRule;
  action: TQuestionRuleAction;
  actionIdx: number;
}

const RuleAction = ({ rule, action, actionIdx }: Props) => {
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <RuleActionFields
      index={actionIdx}
      isReadOnly={isReadOnly}
      onRemove={() => dispatch(upsertQuestionRule({ questionId, rule: removeActionAt(rule, actionIdx) }))}
    >
      {action.name === 'JUMP_TO' ? <RuleActionJumpTo rule={rule} action={action} actionIdx={actionIdx} /> : null}
    </RuleActionFields>
  );
};

export default RuleAction;
